import React, { useEffect, useState } from "react"
import { useDispatch } from "react-redux"

import {
  Button,
  styled,
  TextField,
  Typography,
  useTheme
} from "@mui/material"

import { ChevronRightRounded } from "@mui/icons-material"

import {
  useNavigate,
  useSearchParams
} from "react-router-dom"

import SubNav from "../components/SubNav"

import RichText from "../components/StyledComponents/RichText"

import { GetThemes } from "../store/reducers/functions"
import HKVLink from "../components/HKVLink"

const StyledInPageNav = styled("nav", {
})(({ theme }) => {
  return {
    display: "block",
    flexBasis: 240,
    [theme.breakpoints.down("lg")]: {
      flexBasis: 0
    }
  }
})

const StyledResultList = styled("ul", {
})(({ theme }) => {
  return {
    listStyle: "none",
    padding: 0,
    "& .teaser-list-item": {
      borderBottom: `1px solid ${theme.palette.grey[300]}`,
      display: "flex",
      padding: theme.spacing(2, 0),
      width: "100%"
    },
    "& .teaser-list-item-head p": {
      color: theme.palette.grey[600],
      textTransform: "uppercase",
      fontWeight: 600,
    },
    "& .teaser-list-item-body-wrapper": {
      display: "flex",
      flexGrow: 1,
      flex: 1,
      flexDirection: "column"
    },
    "& .teaser-list-item-meta": {
      color: theme.palette.grey[700]
    }
  }
})

const Zoeken = (props) => {
  const dispatch = useDispatch()
  const theme = useTheme()

  const navigate = useNavigate()

  const [searchParams] = useSearchParams()
  const keyword = searchParams.get("keyword")

  const [value, setValue] = useState()
  const [results, setResults] = useState([])

  useEffect(() => {
    setValue(keyword)

    if (keyword) {
      dispatch(GetThemes({ keyword: keyword }))
        .then((json) => {
          const data = Array.isArray(json) ? json : []

          setResults(data.map(d => {
            return {
              category: d.category.name,
              name: d.name,
              description: d.description,
              link: `/themas/${d.category.key}/${d.key}`
            }
          }))
        })
    }

    return () => {
      props.onUnmount()
    }
  }, [keyword])

  return (
    <div className="page-detail">
      <SubNav />
      <div className="page-detail-content">
        <section className="section section-intro">
          <div className="section-body">
            <div className="intro">
              <Typography variant="h1" className="intro-title">Zoeken</Typography>
            </div>
          </div>
        </section>
        <section className="section section-form">
          <div className="section-body">
            <RichText grey sx={{ display: "flex", flexDirection: "column" }}>
              <Typography sx={{ fontWeight: 700 }}>Trefwoord</Typography>
              <TextField
                value={value || ""}
                onChange={(event) => setValue(event.target.value)}
                onKeyDown={(event) => {
                  if (event.key === "Enter") {
                    navigate(`/zoeken?keyword=${value}`)
                  }
                }}
                sx={{ background: "white", margin: theme.spacing(1, 0, 3) }}
                size="small"
              />
              <Button
                disableElevation
                variant="contained"
                endIcon={<ChevronRightRounded />}
                size="large"
                sx={{
                  width: "fit-content",
                  "&:hover": {
                    textDecoration: "underline"
                  }
                }}
                onClick={() => {
                  navigate(`/zoeken?keyword=${value}`)
                }}
              >
                <Typography sx={{ fontSize: theme.typography.pxToRem(18), fontWeight: 700 }}>Zoeken</Typography>
              </Button>
            </RichText>
          </div>
        </section>
        <section className="section section-teaser-list">
          <div className="section-head">
            <Typography variant="h2" role="status">{results.length > 0
              ? `Er zijn ${results?.length} resultaten gevonden.`
              : `Er zijn geen resultaten gevonden met deze zoekcriteria.`
            }</Typography>
          </div>
          <div className="section-body" style={{ borderTop: `1px solid ${theme.palette.grey[200]}` }}>
            <StyledResultList>
              {results.map((result, ix) => (
                <li key={ix} className="teaser-list-item">
                  <HKVLink
                    to={result.link}
                    sx={{
                      "&:hover": {
                        textDecoration: "none",
                        "& .teaser-list-item-title": {
                          textDecoration: "underline",
                          textDecorationThickness: 2
                        }
                      }
                    }}
                  >
                    <div className="teaser-list-item-body-wrapper">
                      <div className="teaser-list-item-head">
                        <Typography variant="body2" color="hemelblauw">{result.category}</Typography>
                      </div>
                      <Typography variant="h3" color="hemelblauw" className="teaser-list-item-title">
                        {result.name}
                      </Typography>
                      <div className="teaser-list-item-description">
                        <Typography>{result.description}</Typography>
                      </div>
                      <div className="teaser-list-item-meta">
                        <Typography variant="body2">{result.link}</Typography>
                      </div>
                    </div>
                  </HKVLink>
                </li>
              ))}
            </StyledResultList>
          </div>
        </section>
      </div>
      <StyledInPageNav className="page-detail-inpagenav" />
    </div>
  )
}

export default React.memo(Zoeken)